<template>
  <div class="meteor-shower">
    <div class="video-container">
      <div v-if="isSafari" class="bg-image"></div>
      <video width="100%" autoplay="autoplay" loop="loop" muted="muted" v-else>
        <source
          src="https://summit-img.geekpark.net/ifx/videos/%E6%B5%81%E6%98%9F%E9%9B%A8-%E6%9C%80%E7%BB%88.2019-10-23%2014_29_12.mp4"
          type="video/mp4">
      </video>
    </div>
    <img src="https://summit-img.geekpark.net/%E5%9B%9E%E9%A1%BE%E8%BF%87%E5%BE%80%E5%8D%81%E5%B9%B4.svg"
         style="left: 0">
    <img src="https://summit-img.geekpark.net/%E7%9C%BA%E6%9C%9B%E4%B8%8B%E4%B8%80%E4%B8%AA%E5%8D%81%E5%B9%B4.svg"
         style="right: 0;">
  </div>
</template>

<script>
export default {
  name: 'MeteorShower',
  props: ['isSafari']
}
</script>

<style scoped lang="less">
  .meteor-shower {
    position: relative;
    width: 208vh;
    height: 100%;
    box-sizing: border-box;

    img {
      height: 86%;
      position: absolute;
      top: 7%;
    }
  }

  .video-container {
    position: relative;
    width: 100%;
    height: 100%;
    z-index: -10;

    .bg-image {
      width: 100%;
      height: 100%;
      background: url("https://summit-img.geekpark.net/ifx/videos/%E6%B5%81%E6%98%9F%E9%9B%A8-%E6%9C%80%E7%BB%88.2019-10-23%2014_29_12.mp4") 0 0/cover;
    }

    video {
      height: 100%;
    }
  }
</style>
